import { useState } from "react";
import { toast } from "sonner";
import { HeartScribble } from "./Logo";

export default function WaitlistCTA() {
    const [email, setEmail] = useState("");
    const [done, setDone] = useState(false);

    const submit = (e) => {
        e.preventDefault();
        if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
            toast.error("That doesn't look like a valid email.");
            return;
        }
        setDone(true);
        toast.success("You're in. We'll send your alpha invite soon ♥");
        setEmail("");
    };

    return (
        <section
            id="waitlist"
            className="relative py-28 lg:py-40 bg-[var(--ink)] text-[var(--paper)] overflow-hidden"
            data-testid="waitlist-section"
        >
            <div className="absolute inset-0 opacity-15 pointer-events-none">
                <div
                    className="absolute inset-0"
                    style={{
                        backgroundImage:
                            "radial-gradient(circle at 1px 1px, var(--paper) 1px, transparent 0)",
                        backgroundSize: "32px 32px",
                    }}
                />
            </div>
            <div
                className="absolute -top-20 -right-20 w-[480px] h-[480px] rounded-full pointer-events-none"
                style={{
                    background:
                        "radial-gradient(circle, rgba(255,45,107,0.4), transparent 70%)",
                    filter: "blur(60px)",
                }}
            />

            <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
                <div className="reveal flex items-center justify-between flex-wrap gap-3 font-mono text-[10px] uppercase tracking-[0.3em] mb-10 opacity-70">
                    <span>Alpha Wave · 01</span>
                    <span>Postmarked · winter 2026</span>
                </div>

                <h2
                    className="reveal font-display text-7xl sm:text-[10vw] lg:text-[14rem] leading-[0.82] tracking-tighter max-w-6xl"
                    data-testid="waitlist-headline"
                >
                    Meet better{" "}
                    <span className="font-italic-serif text-[var(--hot)]">
                        matches
                    </span>{" "}
                    on Monday.
                </h2>

                <p className="reveal mt-10 max-w-xl text-lg opacity-80 leading-relaxed">
                    Join thousands waiting for a better way to date. Five
                    matches a week. Real conversations. Zero swipe fatigue. No
                    spam — we hate ghosting too.
                </p>

                <form
                    onSubmit={submit}
                    className="reveal mt-12 max-w-2xl flex flex-col sm:flex-row items-stretch gap-3"
                    data-testid="waitlist-form"
                >
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="you@somewhere.com"
                        className="flex-1 bg-transparent border-2 border-[var(--paper)] px-6 py-4 text-lg font-display outline-none placeholder:text-[var(--paper)]/40 focus:border-[var(--hot)]"
                        data-testid="waitlist-email-input"
                    />
                    <button
                        type="submit"
                        className="hot-button inline-flex items-center justify-center gap-3 px-8 py-4 font-mono text-xs uppercase tracking-[0.25em] border-2 border-[var(--hot)]"
                        data-testid="waitlist-submit-button"
                    >
                        {done ? "You're in ♥" : "Get on the list"}
                        <HeartScribble className="w-4 h-4" color="currentColor" />
                    </button>
                </form>

                <div className="reveal mt-6 font-hand text-2xl text-[var(--hot)]">
                    — see you Monday ♥
                </div>
            </div>
        </section>
    );
}
